import $http from '@/core/services/http.service';
import { ActionTree } from 'vuex';

import { State } from '@/manager/product/store/state';
import Endpoints from '@/constants/endpoints';

import UtilsService from '@/core/services/utils.service';

export interface Actions {
    fetchProductList: {  };
}

export const actions: ActionTree<State, any> = {
    fetchProductList: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {};
            params = UtilsService.getQueryParams(payload);
            $http.get(`${Endpoints.product}`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('setProductList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    fetchProductListKeepingStore: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {};
            params = UtilsService.getQueryParams(payload);
            $http.get(`${Endpoints.product}`, { params })
                .then((res) => {
                    const data = res.data;
                    commit('checkSetProductList', data.results);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    // fetchRefundedOriginBill: ({ commit }, payload) => {
    //     return new Promise(( resolve, reject ) => {
    //         $http.get(`${Endpoints.bill}${payload.id}/refunded-origin`)
    //             .then((res) => {
    //                     const data = res.data;
    //                     // commit('updateBill', data);
    //                     resolve(data);
    //             })
    //             .catch((err) => {
    //                 reject(err);
    //             });
    //     });
    // },
};
